import React, { useEffect, useState } from "react";
import Auto from "../../../../assets/images/Auto.png";
import Auth from "../../../../assets/images/Auth.png";
import Unauth from "../../../../assets/images/Unauth.png";
import allApi from "../../../../api/allApi";
import { useLocalization } from "../../localization/LocalizationContext";
import { asSwitchList, switchSerial } from "../../common/configValidation";

function RadiusConfiguration() {
  const {localizationStrings} = useLocalization();
  const [assignedPorts, setAssignedPorts] = useState({});
  const [initialAssignedPorts, setInitialAssignedPorts] = useState({});
  const [enabledServers, setEnabledServers] = useState({});
  const [authMode, setAuthMode] = useState(1);
  const [servers, setServers] = useState([]);
  const [saveMessage, setSaveMessage] = useState("");

  useEffect(() => {
    const fetchSwitches = async () => {
      try {
        const api = new allApi();
        const response = await api.getRequest("api/vlan/get/allSwitchBasicInfo");
        const list = asSwitchList(response).map((device, index) => ({
          id: switchSerial(device) || index,
          name: device.model || switchSerial(device) || `Switch ${index + 1}`,
          ports: Number(device.numberOfPorts) || device.portMembers?.length || 0,
        }));
        setServers(list);
      } catch (error) {
        console.error("Error fetching RADIUS devices", error);
        setServers([]);
      }
    };
    fetchSwitches();
  }, []);

const portConfig = async () => {
  try {
    const api = new allApi();

    const payload = Object.entries(assignedPorts).flatMap(([serverId, ports]) => {
      if (enabledServers[serverId] === false) return [];
      return Object.entries(ports)
        .filter(([, config]) => config)
        .map(([portNumber, config]) => ({
          portId: parseInt(portNumber, 10),
          portControlMode: config.portControlMode || authMode,
        }));
    });

    if (payload.length === 0) {
      setSaveMessage("Select at least one port.");
      return;
    }

    const response = await api.postRequest("api/wired/conf/radiusPortConfig","",payload);
    if (response) {
      setInitialAssignedPorts(assignedPorts);
      setSaveMessage("");
    }
  } catch (error) {
    console.error("Error in port configuration", error);
  }
};



const togglePort = (serverId, portNumber) => {
  setAssignedPorts((prev) => ({
    ...prev,
    [serverId]: {
      ...prev[serverId],
      [portNumber]: prev[serverId]?.[portNumber]
        ? null // Deselect port
        : { portControlMode: 1 }, // Default control mode when selecting
    },
  }));
};


const handleSelectAllPorts = (serverId, totalPorts) => {
  setAssignedPorts((prev) => {
    const newState = { ...prev };
    if (!newState[serverId]) newState[serverId] = {};

    const allSelected = Object.keys(newState[serverId]).length === totalPorts;

    for (let i = 1; i <= totalPorts; i++) {
      newState[serverId][i] = allSelected ? null : { portControlMode: 1 };
    }
    return newState;
  });
};

  return (
    <div>
      <div className="tab-form">
        <div className="row mb-4">
          <div className="col-lg-6">
            <div className="switch-box">
              <strong className="radius-help">
                {localizationStrings?.radiusInfo}
                <span data-bs-toggle="modal" data-bs-target="#radiusHelp"><i className="fa fa-question-circle-o" aria-hidden="true"></i></span>
              </strong>              
            </div>
          </div>
        </div>
        <div className="mt-3">
      {servers.map((server) => (
        <div key={server.id} className="radius-device">
          <div className="radius-device-title">
            <h3>{server.name} - {server.ports} {localizationStrings?.port}</h3>
          </div>
          <div className="radius-device-body">
            <div className="row">
              <div className="col-lg-4">
                <div className="switch-box">
                  <strong>{server.name}</strong>
                  <label className="ice-switch">
                    <input
                      type="checkbox"
                      checked={enabledServers[server.id] !== false}
                      onChange={() =>
                        setEnabledServers((prev) => ({
                          ...prev,
                          [server.id]: prev[server.id] === false,
                        }))
                      }
                    />
                    <span className="slider"></span>
                  </label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="router-port left mt-3">
                  <div className="mxw-1260">
                    <div className="polygon"></div>
                    <div className="port-box">
                      <ul className={`port${server.ports}`}>
                        {[...Array(server.ports)].map((_, index) => {
                          const portNumber = index + 1;
                          return (
                            <li
                              key={portNumber}
                              className={
                                assignedPorts[server.id]?.[portNumber] ? "assign" : "unassign"
                              }
                              onClick={() => togglePort(server.id, portNumber)}
                            >
                              {portNumber}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="radius-device-footer schedule-btn">
            <button
              type="button"
              className="btn btn-outline"
              data-bs-toggle="modal"
              data-bs-target="#radiusPortAuth"
            >
              {localizationStrings?.portAuthenticationMode}
            </button>
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => handleSelectAllPorts(server.id, server.ports)}
            >
              {localizationStrings?.selectAll}
            </button>
          </div>
        </div>
      ))}
    </div>
      </div>
      <div className="wifi-footer">
        <button
          type="button"
          className="btn btn-outline"
          onClick={() => {
            setAssignedPorts(initialAssignedPorts);
            setSaveMessage("");
          }}
        >
          {localizationStrings?.cancel}
        </button>
        <button type="submit" className="text-btn primary-btn" onClick={()=>portConfig()}>
          {localizationStrings?.save}
        </button>
      </div>

      <div className="modal fade radius-help-modal" id="radiusHelp" tabindex="-1" aria-labelledby="radiusHelp" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="radiusHelpLabel">{localizationStrings?.radiusConfiguration}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p><strong>{localizationStrings?.portAuthInfo}</strong></p>
              <ul>
                <li>
                  <span>
                    <img src={Auto} alt="Unauthorized" />
                  </span>
                  <p>
                    <strong>{localizationStrings?.auto}</strong>
                    {localizationStrings?.portAuto}
                  </p>
                </li>
                <li>
                  <span>
                    <img src={Auth} alt="Unauthorized" />
                  </span>
                  <p>
                    <strong>{localizationStrings?.authorized}</strong>
                    {localizationStrings?.portAuth}
                  </p>
                </li>
                <li>
                  <span>
                    <img src={Unauth} alt="Unauthorized" />
                  </span>
                  <p>
                    <strong>{localizationStrings?.unAuthorized}</strong>
                    {localizationStrings?.portUnauth}
                  </p>
                </li>
              </ul>
            </div>            
          </div>
        </div>
      </div>


      <div className="modal fade radius-help-modal" id="radiusPortAuth" tabindex="-1" aria-labelledby="radiusPortAuth" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered medium">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="radiusPortAuthLabel">{localizationStrings?.deviceMode}</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <p><strong>{localizationStrings?.selectPortAuth}</strong></p>
              <ul>
                <li>
                  <span>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="auth"
                        checked={authMode === 1}
                        onChange={() => setAuthMode(1)}
                      />
                    </div>
                  </span>
                  <p>
                    <strong>{localizationStrings?.auto}</strong>
                    {localizationStrings?.portAuto}
                  </p>
                </li>
                <li>
                  <span>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="auth"
                        checked={authMode === 2}
                        onChange={() => setAuthMode(2)}
                      />
                    </div>
                  </span>
                  <p>
                    <strong>{localizationStrings?.authorized}</strong>
                    {localizationStrings?.portAuth}
                  </p>
                </li>
                <li>
                  <span>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="auth"
                        checked={authMode === 3}
                        onChange={() => setAuthMode(3)}
                      />
                    </div>
                  </span>
                  <p>
                    <strong>{localizationStrings?.unAuthorized}</strong>
                    {localizationStrings?.portUnauth}
                  </p>
                </li>
              </ul>
              <div className="modal-footer pb-0">
                <button type="button" className="btn btn-outline" data-bs-dismiss="modal">{localizationStrings?.cancel}</button>
                <button
                  className="text-btn primary-btn"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    setAssignedPorts((prev) => {
                      const next = { ...prev };
                      Object.keys(next).forEach((serverId) => {
                        Object.keys(next[serverId] || {}).forEach((port) => {
                          if (next[serverId][port]) {
                            next[serverId][port] = { portControlMode: authMode };
                          }
                        });
                      });
                      return next;
                    });
                  }}
                >
                  {localizationStrings?.saveContinue}
                </button>
              </div>
            </div>            
          </div>
        </div>
      </div>


      {/* <div className="customModal confirm-modal">
        <div className="modal-dialog modal-dialog-centered small">
          <div className="modal-content inc-modal">
            <div className="modal-body">              
              <p>To avoid losing access to the Internet, make sure that all uplink ports are set to Authorized.</p>              
              <div className="modal-footer">
                <button className="text-btn primary-btn">OK</button>
              </div>
            </div>
          </div>
        </div>
      </div> */}

    </div>
  );
}

export default RadiusConfiguration;